import * as React from "react";
import { useContext, useReducer } from "react";
import { getCookie } from "../Cookie";
var initialState = {
  callData: window.callData,
  country: window.preSelectRegion,
  device: "phone"
};
var selectedRegion = getCookie('selectedRegion');
if (selectedRegion !== '') {
  initialState.country = selectedRegion;
}
export var CountryContext = /*#__PURE__*/React.createContext(null);
export var CountryProvider = function (_a) {
  var reducer = _a.reducer,
    children = _a.children;
  return /*#__PURE__*/React.createElement(CountryContext.Provider, {
    value: useReducer(reducer, initialState)
  }, children);
};
export var useCountryValue = function () {
  return useContext(CountryContext);
};
export default CountryContext;